const isLocalhostHost = (host = '') => host === 'localhost' || host === '127.0.0.1';

export const getBackendOrigin = () => {
  const explicit =
    process.env.REACT_APP_BACKEND_ORIGIN ||
    process.env.REACT_APP_BACKEND_URL ||
    '';
  if (explicit && /^https?:\/\//i.test(explicit)) {
    return String(explicit).replace(/\/+$/, '');
  }

  const apiBaseUrl = process.env.REACT_APP_API_URL || '/api';
  const apiOrigin = String(apiBaseUrl).replace(/\/api\/?$/, '').replace(/\/+$/, '');
  if (/^https?:\/\//i.test(apiOrigin)) return apiOrigin;

  if (typeof window !== 'undefined' && isLocalhostHost(window.location.hostname)) {
    return 'http://localhost:5000';
  }

  // Empty string means "same origin" (production setups where backend serves /uploads).
  return apiOrigin;
};

const joinUrl = (base, path) => {
  const cleanPath = String(path || '').replace(/^\/+/, '');
  if (!base) return `/${cleanPath}`;
  return `${String(base).replace(/\/+$/, '')}/${cleanPath}`;
};

export const resolveUploadsUrl = (value) => {
  if (!value) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalized = raw.replace(/\\/g, '/').replace(/^\/+/, '');
  const idx = normalized.indexOf('uploads/');
  if (idx < 0) return null;

  const uploadPath = normalized.slice(idx);
  return joinUrl(getBackendOrigin(), uploadPath);
};

